export const toPercentage = (dividend, base, shouldSubtract) => {
    return shouldSubtract
        ? parseFloat((((dividend - base) / base) * 100).toFixed(2))
        : parseFloat(((dividend / base) * 100).toFixed(2));
};
